import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { TimezoneService } from "../../services/timezone.service";
import { timezoneActions } from "./timezone.actions";

@Injectable()
export class TimezoneEffect {

    private readonly action$ = inject(Actions);
    private readonly timezoneService = inject(TimezoneService);

    loadTimezoneFromApi$ = createEffect(() => {
        return this.action$.pipe(
            ofType(timezoneActions["[Timezone-API]LoadTimezone"]),
            switchMap((payload) => this.timezoneService.getTimezone(payload.payload).pipe(
                map(countryResponse => timezoneActions["[Timezone-API]LoadSuccess"](countryResponse)),
                catchError((countryResponse) => of(timezoneActions["[Timezone-API]LoadFailed"](countryResponse)))
            ))
        )
    })

    // createTimezoneFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Timezone-API]CreateTimezone"]),
    //         switchMap((payload) => this.countryService.(payload.payload).pipe(
    //             mergeMap(res => this.countryService.getEventById(<any>res.data?.id)),
    //             map(countryResponse => countryActions["[Timezone-API]EventCreated"](countryResponse)),
    //             catchError((countryResponse) => of(countryActions["[Timezone-API]EventCreatedFailed"](countryResponse)))
    //         ))
    //     )
    // })

    // updateTimezoneFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Timezone-API]updateEvent"]),
    //         switchMap((payload) => this.countryService.updateEvent(payload.payload).pipe(
    //             mergeMap(() => this.countryService.getEvents()),
    //             map((countryResponse) => countryActions["[Timezone-API]EventUpdated"](countryResponse)),
    //             catchError(() => of(countryActions["[Timezone-API]EventUpdatedFailed"]()))
    //         ))
    //     )
    // })

    // deleteTimezoneFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Timezone]-API]deleteEvent"]),
    //         switchMap((payload) => this.countryService(payload.payload).pipe(
    //             map(countryResponse => countryActions["[Timezone-API]EventUpdated"](countryResponse)),
    //             catchError((countryResponse) => of(countryActions["[Timezone-API]EventUpdatedFailed"](countryResponse)))
    //         ))
    //     )
    // })
}